import { useAppSelector } from 'app/hooks';
import { Genre } from 'features/MenuBook/models';
import { memo } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { getListStyle } from '../MenuBookEditorModal';
import MenuRowList from '../MenuRowList';
import SubGenreRow from '../SubGenreRow';

export interface SubGenreRowListProps {
  // genre: Genre;
  genreId: number;
  onSelectedRowChanged: () => void;
}

function SubGenreRowList({ genreId, onSelectedRowChanged }: SubGenreRowListProps) {
  const genre = useAppSelector((state) => {
    return state.menuBookEditor.data.find((genre) => genre.id === genreId);
  }) as Genre;

  const pathId = `${genre.id}`;

  return (
    <Droppable droppableId={`genre-${pathId}`} type={`subgenre-${pathId}`}>
      {(provided, snapshot) => (
        <div {...provided.droppableProps} ref={provided.innerRef} style={getListStyle(snapshot.isDraggingOver)}>
          {genre.subgenres.map((subgenre, index) => (
            <SubGenreRow
              key={`subgenre-${genreId}-${subgenre.id}`}
              genreId={genre.id}
              genreName={genre.name}
              subgenreId={subgenre.id}
              index={index}
              onSelectedRowChanged={onSelectedRowChanged}
            >
              <MenuRowList
                genreId={genre.id}
                genreName={genre.name}
                subgenreId={subgenre.id}
                onSelectedRowChanged={onSelectedRowChanged}
              />
            </SubGenreRow>
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
}

export default memo(SubGenreRowList);
